"use strict";
var fs = require('fs');
var jpeg = require('jpeg-js');
var os = require('os');
var m = require('./mathTimo');

function deleteFile(filename) {
    if (fs.existsSync(filename)) fs.unlinkSync(filename);
}





module.exports = {

    deleteFile: function (filename) {
        deleteFile(filename);
    },
    writeToFile: function (filename, text) {
        var id = fs.openSync(filename, 'a', 666);
        fs.writeSync(id, text + os.EOL, null, 'utf8');
        fs.closeSync(id);
    },
    bandToFile: function (path, fileName, band, width) {
        var max = m.max(band);
        var file = path + fileName;
        var height = band.length / width;
        var frameData = new Buffer(width * height * 4);
        var i = 0;
        var bPixel = 0;
        while (i < width * height) {
            bPixel = (band[i] * 255 / max) | 0;
            frameData[i * 4] = bPixel; // red
            frameData[i * 4 + 1] = bPixel; // green
            frameData[i * 4 + 2] = bPixel; // blue
            frameData[i * 4 + 3] = 0xFF; // alpha - ignored in JPEGs
            i++;
        }
        var rawImageData = {
            data: frameData,
            width: width,
            height: height
        };
        var jpegImageData = jpeg.encode(rawImageData, 90);
        jpegImageData.width = width;
        jpegImageData.height = height;
        deleteFile(file);
        fs.writeFileSync(file, jpegImageData.data);
    },
    pageToFile: function (path, fileName, band, width, color) {
        var max = m.max(band);
        var file = path + fileName;
        var height = band.length / width;
        var frameData = new Buffer(width * height * 4);
        var i = 0;
        var bPixel = 0;
        while (i < width * height) {
            bPixel = (band[i] * 192 / max) | 0;
            if (color) {
                frameData[i * 4] = 0; // red
                frameData[i * 4 + 1] = 0; // green
                frameData[i * 4 + 2] = 0; // blue
                if(color=='red')frameData[i * 4] = bPixel; // red
                if(color=='green')frameData[i * 4 + 1] = bPixel; // green
                if(color=='blue')frameData[i * 4 + 2] = bPixel; // blue

            } else {
                frameData[i * 4] = bPixel; // red
                frameData[i * 4 + 1] = bPixel; // green
                frameData[i * 4 + 2] = bPixel; // blue
            }
            frameData[i * 4 + 3] = 0xFF; // alpha - ignored in JPEGs
            i++;
        }
        var rawImageData = {
            data: frameData,
            width: width,
            height: height
        };
        var jpegImageData = jpeg.encode(rawImageData, 90);
        jpegImageData.width = width;
        jpegImageData.height = height;
        if (!fs.existsSync(file)) fs.writeFileSync(file, jpegImageData.data);
    },
    pixelsToFile: function (path, fileName, pixels) {
        var file = path + fileName;
        var jpegImageData = jpeg.encode(pixels, 90);
        jpegImageData.width = pixels.width;
        jpegImageData.height = pixels.height;
        deleteFile(file);
        fs.writeFileSync(file, jpegImageData.data);
    },

}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/fileTimo.js
// module id = 293
// module chunks = 0